import * as React from 'react';
import Partner from './Partner';
import IconPlus from './IconPlus';
var Reseau = function (_a) {
    var element = _a.element, setActiveId = _a.setActiveId, activeId = _a.activeId;
    var elementId = parseInt(element.id);
    return (React.createElement("div", { className: "reseau" },
        React.createElement("img", { src: element.logo, alt: element.name, onClick: function () { return setActiveId(elementId === activeId ? 0 : elementId); }, className: activeId === elementId ? "reseau-img active-reseau" : "reseau-img" }),
        React.createElement(IconPlus, { element: element, setActiveId: setActiveId, activeId: activeId }),
        activeId === elementId ?
            React.createElement("div", { className: "reseau-items" }, element.items && element.items.map(function (item) {
                return (React.createElement(Partner, { element: item, activeId: activeId, setActiveId: setActiveId }));
            }))
            : null));
};
export default Reseau;
